// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2ix7x","label":"Labeled_label__3ugpl","divider":"Labeled_divider__3ziOf"};